<template>
  <div class="wrapper" id="teacher">
    <section class="wmtg">
      <div class="title-box">
        <h2 class="title">我们为您提供</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <div class="card">
          <img class="card-img" src="../assets/img/img-zntk.png" alt="智能题库">
          <p class="card-name">智能题库</p>
          <p class="card-text">知心慧学为您提供内容丰富的动态智能题库。它分类详细，各类题目一应俱全；试题每日更新，每道都详细标注了知识点、考点属性。大量教师精编套卷、自主研发套卷，全面满足您的组卷需求！</p>
        </div>
        <div class="card">
          <img class="card-img" src="../assets/img/img-yjxt.png" alt="阅卷系统">
          <p class="card-name">阅卷系统</p>
          <p class="card-text">同时支持网上阅卷和纸笔阅卷，客观题自动批阅，两种阅卷方式均不需要人工统分，系统自动统计。在不改变批改习惯的前提下，助您提升阅卷效率，事半功倍！</p>
        </div>
        <div class="card">
          <img class="card-img" src="../assets/img/img-jxb.png" alt="教学宝">
          <p class="card-name">教学宝</p>
          <p class="card-text">我们在每次考试结束之后为您打印“教学宝”，将答题详情、学情统计、学生成绩动态跟踪表、班级变式训练题等整理成册。是您进行科学备课、精准讲评、个性化教学的必备神器。</p>
        </div>
        <div class="card">
          <img class="card-img" src="../assets/img/img-xqtj.png" alt="学情统计">
          <p class="card-name">学情统计</p>
          <p class="card-text">系统自动收集记录每次考试的详细答题数据，智能分析班级考试学情，分析每道试题的答题情况，自动记录每个知识点的历次得分情况。班级学情统计跃然于纸，一目了然！</p>
        </div>

      </div>
    </section>

    <section class="wmdcp">
      <div class="title-box">
        <h2 class="title">我们的产品</h2>
        <i class="border-bottom"></i>
      </div>
      <div class="content">
        <img class="img-chanping" src="../assets/img/img-chanping.png" alt="">

        <img class="img-line-2" src="../assets/img/img-line-2.png" alt="">
        <span class="jsd">教师端</span>

        <img class="img-line-1" src="../assets/img/img-line-1.png" alt="">
        <span class="jxb">教学宝</span>

      </div>

    </section>
  </div>
</template>
<script type="text/javascript">
  export default {
    data() {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>
<style scoped lang="less">

  @highlight-border: #3ECDBAFF;
  @highlight-background: #50d2c2;

  .title-box {
    .title {
      line-height: 56px;
      font-size: 40px;
      text-align: center;
      color: #333;
    }
    .border-bottom {
      display: block;
      margin: 0 auto;
      padding-top: 16px;
      width: 40px;
      border-bottom: 4px solid @highlight-border;
    }
  }

  .wmtg {
    padding-top: 80px;
    padding-bottom: 80px;
    .content {
      padding-top: 80px;
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      justify-content: space-between;
      .card {
        width: 280px;
        height: 400px;
        padding: 40px 20px;
        box-sizing: border-box;
        &:hover {
          box-shadow: 0px 0px 20px 0px rgba(238, 238, 238, 1);
        }
        .card-img {
          display: block;
          width: 96px;
          height: 96px;
          margin: 0 auto;
        }
        .card-name {
          margin-top: 40px;
          margin-bottom: 20px;
          font-size: 24px;
          line-height: 33px;
          color: #333;
          text-align: center;

        }
        .card-text {
          font-size: 14px;
          line-height: 26px;
          text-align: center;
          color: #666;
        }
      }
    }
  }

  .wmdcp {
    padding-top: 80px;
    padding-bottom: 27px;
    background-color: #fafafa;
    .title-box {
      margin-bottom: 30px;
    }
    .content {
      position: relative;
      width: 911px;
      height: 617px;
      margin: 0 auto;
      /*border: 1px dashed #888;*/
      .img-chanping {

      }
      .img-line-2 {
        position: absolute;
        left: 74px;
        top: 442px;
      }
      .jxb {
        position: absolute;
        left: 154px;
        top: 527px;
      }
      .img-line-1 {
        position: absolute;
        left: 474px;
        top: 293px;
      }
      .jsd {
        position: absolute;
        left: 554px;
        top: 527px;
      }
      .jxb, .jsd {
        font-size: 30px;
        line-height: 42px;
        color: #3ECDBA;
        font-weight: 500;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// Teacher.vue?5eb1ba96